/* jshint ignore:start */
const routes = [
  {
    // not found handler
    path: '/invalid-url',
    component: () =>
      import('./views/auth/partner-not-found.vue'),
    name: 'invalid-token',
    meta: {
      title: 'Url Inválida',
      noCache: false,
      autoClose: true,
      ignoreAuth: true
    }
  },
  {
    path: '/login/:lojaUrl',
    component: () => import('./views/auth'),
    name: 'login',
    meta: {
      requiresAuth: false
    }
  },
  {
    path: '/participante/cadastrar',
    component: () => import('./views/auth/sign-up'),
    name: 'signup',
    meta: {
      requiresAuth: false
    }
  },
  {
    path: '/confirmar-email/:tokenId',
    component: () => import('./views/auth/index'),
    name: 'confirmEmail',
    meta: {
      requiresAuth: false,
      ignoreAuth: true,
    },
  },
  {
    path: '/usuario/registrar/:tokenId',
    component: () => import('./views/auth/index'),
    name: 'confirmarCadastroVinculo',
    meta: {
      //requiresAuth: false,
      ignoreAuth: true,
    },
  },
  {
    path: '/usuario/cadastrar/:tokenId',
    component: () => import('./views/auth/index'),
    name: 'confirmarCadastro',
    meta: {
      //requiresAuth: false,
      ignoreAuth: true,
    },
  }, 
  {
    // not found handler
    path: '*',
    component: () =>
      import('./views/auth'),
    name: '404_public',
    meta: {
      title: '404',
      noCache: false,
      autoClose: true
    }
  },
  {
    path: '/password/recovery',
    component: () => import('./views/auth/recovery-password'),
    name: 'recoveryPassword',
    meta: {
      requiresAuth: false
    }
  },
  {
    path: '/api/password/reset/:token',
    component: () => import('./views/auth/reset-password'),
    name: 'resetPassword',
    meta: {
      requiresAuth: false
    }
  },
  {
    path: '/cadastrar-usuario/:token',
    component: () => import('./views/auth'),
    name: 'storeUser',
    meta: {
      requiresAuth: false
    }
  },
  {
    path: '/home',
    component: () => import('./views/MasterPage'),
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: '/dashboard',
        component: () =>
          import('./views/dashboard/dashboard'),
        name: 'dashboard',
        meta: {
          title: 'dashboard',
          noCache: true,      
        }
      },
      {
        path: '/vouchers',
        component: () =>
          import('./views/voucher/index'),
        name: 'vouchers',
        meta: {
          title: 'vouchers',
          noCache: true,
        }
      },
      {
        path: '/historico',
        component: () =>
          import('./views/history/index'),
        name: 'extrato',
        meta: {
          title: 'Extrato',
          noCache: true,
        }
      },
      {
        path: '/profile',
        component: () =>
          import('./views/users/profile.vue'),
        name: 'profile',
        meta: {
          title: 'profile',
          noCache: true
        }
      },
      {
        path: '/notifications',
        component: () =>
          import('./views/users/notifications.vue'),
        name: 'notifications',
        meta: {
          title: 'notifications',
          noCache: true
        }
      },
      {
        // not found handler
        path: '*',
        component: () =>
          import('./views/errors/404.vue'),
        name: '404',
        meta: {
          title: '404',
          noCache: false,
          autoClose: true
        }
      },
      {
        // not found handler
        path: '/404',
        component: () =>
          import('./views/errors/404.vue'),
        name: 'notFound',
        meta: {
          title: '404',
          noCache: false,
          autoClose: true
        }
      },
      {
        // not found handler
        path: '/403',
        component: () =>
          import('./views/errors/403.vue'),
        name: '403',
        meta: {
          title: '403',
          noCache: false,
          autoClose: true
        },
        props: true
      },
      {
        path: '/451',
        component: () =>
          import('./views/errors/451.vue'),
        name: '451',
        meta: {
          title: '451',
          noCache: false,
          autoClose: true
        },
        props: true
      },
      {
        path: '/401',
        component: () =>
          import('./views/errors/401.vue'),
        name: '401',
        meta: {
          title: '401',
          noCache: false,
          autoClose: true
        }
      },

    ]
  },
  {
    path: '/:lojaUrl',
    component: () => import('./views/auth'),
    name: 'loginIndex',
    meta: {
      requiresAuth: false,
    }
  },
];
export default routes;